const userIdRegex = new RegExp(/<userID>(.+)<\/userID>/g);
const ncsIdRegex = new RegExp(/<ncsID>(.+)<\/ncsID>/g);

// ToDo: Make a real parser for app info.

export const getUserIdFromNcsAppInfo = (message) => {
  // Yeah I know, regex to parse an xml value..  Sue me
  const userIdMatch = userIdRegex.exec(message);
  return userIdMatch ? userIdMatch[1] : null;
};

export const getNcsIdFromNcsAppInfo = (message) => {
  const ncsIdMatch = ncsIdRegex.exec(message);
  return ncsIdMatch ? ncsIdMatch[1] : null;
};



// WEBPACK FOOTER //
// ./app/util/ncsUtils.js